//angular references
import { Component, Inject, OnInit } from '@angular/core';
//import { NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

//BusinessEvent control references
import { BEDataService } from '../../services/businessEvent/beData.service';
import { BEWorkflowSteps } from '../../services/businessEvent/beWorkflow.model';

//Config references
import { ConfigDataService, enumClientConfig, enumUIConfig } from '../../services/configuration/configData.service';

//Era model references
import { BusinessEvent } from '../../models/businessevent.model';
import { OTA_VehAvail } from '../../models/ota_vehavail.model';
import { OTA_Charge } from '../../models/ota_charge.model';
import { OTA_PricedEquip } from '../../models/ota_pricedequip.model';
import { OTA_PricedCoverage } from '../../models/ota_pricedcoverage.model';
import { Dialog } from '../../models/dialog.model';
import { DialogButton, enumDialogButtonType } from '../../models/dialogButton.model';

import { ConfirmationService } from 'primeng/api';
import { CurrencyAmount } from '../../models/currencyamount.model';
import { Subscription } from 'rxjs/Subscription';
import { KeyValuePair } from '../../models/keyvaluepair.model';

enum enumCostDisplayMode {
    exCost_DailyRate = 1,
    exCost_Total = 2,
}

enum enumAsyncLoad {
    UIConfigs = 1,
    ClientConfigs = 2,
};

@Component({
    selector: 'beExtras',
    template: require('./beExtras.component.html'),
    styles: [require('../app/app.component.css')]
})

export class BEExtrasComponent {
    //page/workflow 
    private _title = 'Choose your extras';
    private _currentStep = BEWorkflowSteps.beExtras;
    private _nextStep = "";
    private _previousStep = "";
    private _subscriptions: Subscription[] = [];
    private _fullyLoaded: boolean = false;

    private _font: string = "";
    private _textColour: string = "";
    private _invalidTextColour: string = "";
    private _invalidBorderColour: string = "";
    private _containerBackColour: string = "";
    private _containerBorderColour: string = "";
    private _containerCornerRadius: string = "";
    private _inactiveTabColour: string = "";
    private _containerBorderFull: string = "";
    private _commandButtonFont: string = "";
    private _commandButtonRadius: string = "";
    private _commandButtonTextSize: string = "";
    private _commandButtonTextWeight: string = "";
    private _primaryCommandButtonTextColour: string = "";
    private _primaryCommandButtonBackColour: string = "";
    private _primaryCommandButtonBorderFull: string = "";
    private _secondaryCommandButtonTextColour: string = "";
    private _secondaryCommandButtonBackColour: string = "";
    private _secondaryCommandButtonBorderFull: string = "";
    private _subContainerBorderColour: string = "";
    private _subContainerBorderFull: string = "";
    private _subContainerHeaderTextColour: string = "";
    private _subContainerBackgroundColour: string = "";
    private _checkboxTickColour: string = "";
    private _checkboxTickedBackColour: string = "";
    private _checkboxUntickedBackColour: string = "";
    private _checkboxBorderColour: string = "";

    private _baseVehImgURL = "/img/vehicleImages/";
    private _baseExtraImgURL: string = "/img/extraImages/";
    private _baseIconImgURL: string = "/img/icons/";

    private _showDailyRate = false;
    private _showTotalCost = true;

    private _extras_Desc_ColClass = "col-xs-5";
    private _extras_Rate_ColClass = "col-xs-3";
    private _extras_Cost_ColClass = "col-xs-3";
    private _extras_Add_ColClass = "col-xs-4";

    private _covers_Desc_ColClass = "col-xs-5";
    private _covers_Liability_ColClass = "col-xs-3";
    private _covers_Rate_ColClass = "col-xs-2";
    private _covers_CostAdd_ColClass = "col-xs-4";
    private _covers_Cost_SubColClass = "col-sm-3";
    private _covers_Add_SubColClass = "col-sm-9";

    //business event parameters
    private _be: BusinessEvent;
    private _otaPricedCoverage: OTA_PricedCoverage;
    private _originalOTAPricedCoverage: OTA_PricedCoverage;
    private _locationOut: string = "";
    private _locationIn: string = "";
    private _dateTimeOut: string;
    private _dateTimeIn: string;
    private _vehicleSIPP: string;
    private _selectedVehicle: OTA_VehAvail;
    //private _totalCostDescription: string;
    private _deliveryAddress: string = "";
    private _collectionAddress: string = "";
    private _reference: string = "";
    private _singleCoverageSelected: boolean = false;
    private _originalSingleCoverageSelected: boolean = false;

    //lists
    private _singleAllowedEquips = new Array<boolean>();
    private _otaPricedEquips: OTA_PricedEquip[];
    private _otaPricedCoverages: OTA_PricedCoverage[];

    //error/change tracking
    private _hasChanged = false;
    private _hasError = false;

    //dialog
    private _dialog: Dialog = new Dialog();

    private _loaded = [
        {
            step: enumAsyncLoad.UIConfigs,
            loaded: false,
        },
        {
            step: enumAsyncLoad.ClientConfigs,
            loaded: false,
        },
    ];

    //
    //component events
    //
    public constructor(private _router: Router,
        private _beDataService: BEDataService,
        private _configDataService: ConfigDataService,
        private _httpClient: HttpClient,
        @Inject('BASE_URL') private _baseUrl: string,
        private _confirmationService: ConfirmationService)
    {
        this._nextStep = this._beDataService.nextStep(this._currentStep);
        this._previousStep = this._beDataService.previousStep(this._currentStep);
    }

    private async ngOnInit() {
        //get the BusinessEvent data
        this._be = this._beDataService.getBusinessEventForStep(this._currentStep);

        //get the configured UIConfigs
        if (this._configDataService.uiConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/UIConfigs').subscribe(result => {
                this._configDataService.uiConfigs = result;
                this.asyncLoaded(enumAsyncLoad.UIConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.UIConfigs);

        //get the configured ClientConfigs
        if (this._configDataService.clientConfigs == null) {
            this._httpClient.get<KeyValuePair[]>(this._baseUrl + 'api/ConfigData/ClientConfigs').subscribe(result => {
                this._configDataService.clientConfigs = result;
                this.asyncLoaded(enumAsyncLoad.ClientConfigs);
            }, error => console.error(error));
        }
        else
            this.asyncLoaded(enumAsyncLoad.ClientConfigs);

    }

    //private async ngDoCheck() {
    private async ngAfterViewChecked () {
        //style the checkboxes based on their state
        if ((this._checkboxTickColour.length > 0)
            || (this._checkboxTickedBackColour.length > 0)
            || (this._checkboxUntickedBackColour.length > 0)
            || (this._checkboxBorderColour.length > 0)) {

            //default with unticked style
            var checkboxes = document.getElementsByClassName('ui-chkbox-box') as HTMLCollectionOf<HTMLElement>;
            Array.from(checkboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxUntickedBackColour;
                checkbox.style.borderColor = this._checkboxBorderColour;
            });

            //apply ticked style to any ticked checkboxes
            var tickedCheckboxes = document.getElementsByClassName('ui-chkbox-box ui-state-active') as HTMLCollectionOf<HTMLElement>;
            Array.from(tickedCheckboxes).forEach(checkbox => {
                checkbox.style.backgroundColor = this._checkboxTickedBackColour;
                checkbox.style.color = this._checkboxTickColour;
            });
        }
    }

    //
    //component management
    //
    private asyncLoaded(step: enumAsyncLoad) {
        let fullyLoaded: boolean = true;

        for (var i = 0; i < this._loaded.length; i++) {
            if (this._loaded[i].step === step) {
                //record the given step as being loaded
                this._loaded[i].loaded = true;
            }
            else if (!this._loaded[i].loaded) {
                //check if all async steps have been loaded
                fullyLoaded = false;
            }
        }

        switch (step) {
            case enumAsyncLoad.UIConfigs:
                let font: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_Font);
                let textColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_TextColour);
                let invalidTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidTextColour);
                let invalidBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InvalidControlBorderColour);
                let containerBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBackgroundColour);
                let containerBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderColour);
                let containerCornerRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerCornerRadius);
                let inactiveTabColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_InactiveTabColour);
                let containerBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_ContainerBorderStyle);

                let commandButtonFont: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonFont);
                let commandButtonRadius: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonRadius);
                let commandButtonTextSize: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextSize);
                let commandButtonTextWeight: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CommandButtonTextWeight);

                let primaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonTextColour);
                let primaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBackgroundColour);
                let primaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderColour);
                let primaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_PrimaryCommandButtonBorderStyle);

                let secondaryCommandButtonTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonTextColour);
                let secondaryCommandButtonBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBackgroundColour);
                let secondaryCommandButtonBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderColour);
                let secondaryCommandButtonBorderStyle: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SecondaryCommandButtonBorderStyle);

                let subContainerBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SubContainerBorderColour);
                let subContainerHeaderTextColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SubContainerHeaderTextColour);
                let subContainerBackgroundColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_SubContainerBackgroundColour);

                let checkboxTickColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickColour);
                let checkboxTickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxTickedBackColour);
                let checkboxUntickedBackColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxUntickedBackColour);
                let checkboxBorderColour: string = this._configDataService.getUIConfig(enumUIConfig.uiconf_CheckboxBorderColour);

                if (font.trim().length > 0) {
                    this._font = font;
                }
                if (textColour.trim().length > 0) {
                    this._textColour = textColour;
                }
                if (invalidTextColour.trim().length > 0) {
                    this._invalidTextColour = invalidTextColour;
                }
                if (invalidBorderColour.trim().length > 0) {
                    this._invalidBorderColour = invalidBorderColour;
                }
                if (containerBackColour.trim().length > 0) {
                    this._containerBackColour = containerBackColour;
                }
                if (containerBorderColour.trim().length > 0) {
                    this._containerBorderColour = containerBorderColour;
                }
                if (containerCornerRadius.trim().length > 0) {
                    this._containerCornerRadius = containerCornerRadius;
                }
                if (inactiveTabColour.trim().length > 0) {
                    this._inactiveTabColour = inactiveTabColour;
                }
                if ((containerBorderStyle.trim().length > 0)
                    || (containerBorderColour.trim().length > 0)) {
                    this._containerBorderFull = containerBorderColour + " " + containerBorderStyle;
                }

                if (commandButtonFont.trim().length > 0) {
                    this._commandButtonFont = commandButtonFont;
                }
                if (commandButtonRadius.trim().length > 0) {
                    this._commandButtonRadius = commandButtonRadius;
                }
                if (commandButtonTextSize.trim().length > 0) {
                    this._commandButtonTextSize = commandButtonTextSize;
                }
                if (commandButtonTextWeight.trim().length > 0) {
                    this._commandButtonTextWeight = commandButtonTextWeight;
                }

                if (primaryCommandButtonTextColour.trim().length > 0) {
                    this._primaryCommandButtonTextColour = primaryCommandButtonTextColour;
                }
                if (primaryCommandButtonBackColour.trim().length > 0) {
                    this._primaryCommandButtonBackColour = primaryCommandButtonBackColour;
                }
                if ((primaryCommandButtonBorderStyle.trim().length > 0)
                    || (primaryCommandButtonBorderColour.trim().length > 0)) {
                    this._primaryCommandButtonBorderFull = primaryCommandButtonBorderColour + " " + primaryCommandButtonBorderStyle;
                }
                if (secondaryCommandButtonTextColour.trim().length > 0) {
                    this._secondaryCommandButtonTextColour = secondaryCommandButtonTextColour;
                }
                if (secondaryCommandButtonBackColour.trim().length > 0) {
                    this._secondaryCommandButtonBackColour = secondaryCommandButtonBackColour;
                }
                if ((secondaryCommandButtonBorderStyle.trim().length > 0)
                    || (secondaryCommandButtonBorderColour.trim().length > 0)) {
                    this._secondaryCommandButtonBorderFull = secondaryCommandButtonBorderColour + " " + secondaryCommandButtonBorderStyle;
                }

                if (subContainerBorderColour.trim().length > 0) {
                    this._subContainerBorderColour = subContainerBorderColour;
                }
                if ((containerBorderStyle.trim().length > 0)
                    || (subContainerBorderColour.trim().length > 0)) {
                    this._subContainerBorderFull = subContainerBorderColour + " " + containerBorderStyle;
                }
                if (subContainerHeaderTextColour.trim().length > 0) {
                    this._subContainerHeaderTextColour = subContainerHeaderTextColour;
                }
                if (subContainerBackgroundColour.trim().length > 0) {
                    this._subContainerBackgroundColour = subContainerBackgroundColour;
                }

                if (checkboxTickColour.trim().length > 0) {
                    this._checkboxTickColour = checkboxTickColour;
                }
                if (checkboxTickedBackColour.trim().length > 0) {
                    this._checkboxTickedBackColour = checkboxTickedBackColour;
                }
                if (checkboxUntickedBackColour.trim().length > 0) {
                    this._checkboxUntickedBackColour = checkboxUntickedBackColour;
                }
                if (checkboxBorderColour.trim().length > 0) {
                    this._checkboxBorderColour = checkboxBorderColour;
                }

                break;

            case enumAsyncLoad.ClientConfigs:
                let costDisplayModeString: string = this._configDataService.getClientConfig(enumClientConfig.cconf_ExtraCostDisplayMode);
                if ((costDisplayModeString.length > 0)
                    && (!isNaN(Number(costDisplayModeString)))) {

                    var costDisplayModeNum = Number(costDisplayModeString);
                    this._showDailyRate = ((costDisplayModeNum & enumCostDisplayMode.exCost_DailyRate) > 0);
                    this._showTotalCost = ((costDisplayModeNum & enumCostDisplayMode.exCost_Total) > 0);

                    if (this._showDailyRate) {
                        if (this._showTotalCost) {

                            this._extras_Desc_ColClass = "col-xs-4";
                            this._extras_Rate_ColClass = "col-xs-2";
                            this._extras_Cost_ColClass = "col-xs-2";
                            this._extras_Add_ColClass = "col-xs-4";

                            this._covers_Desc_ColClass = "col-xs-4";
                            this._covers_Liability_ColClass = "col-xs-3";
                            this._covers_Rate_ColClass = "col-xs-2";
                            this._covers_CostAdd_ColClass = "col-xs-3";
                            this._covers_Cost_SubColClass = "col-sm-5";
                            this._covers_Add_SubColClass = "col-sm-7";
                        }
                        else {
                            this._covers_Desc_ColClass = "col-xs-4";
                            this._covers_Liability_ColClass = "col-xs-3";
                            this._covers_Rate_ColClass = "col-xs-2";
                            this._covers_CostAdd_ColClass = "col-xs-3";
                            this._covers_Cost_SubColClass = "col-sm-5";
                            this._covers_Add_SubColClass = "col-xs-12";
                        }
                    }
                    else {
                        if (!this._showTotalCost) {

                            this._extras_Desc_ColClass = "col-xs-7";
                            this._extras_Add_ColClass = "col-xs-5";

                            this._covers_Add_SubColClass = "col-sm-12";
                        }
                    }
                }

                var baseVehImgURL = "/img/vehicleImages/";
                let configVehImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_VehicleImageFolder, baseVehImgURL);
                if (configVehImgURL.trim().length > 0) {
                    this._baseVehImgURL = configVehImgURL;
                }

                var baseExtraImgURL = "/img/extraImages/";
                let configExtraImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_ExtrasImageFolder, baseExtraImgURL);
                if (configExtraImgURL.trim().length > 0) {
                    this._baseExtraImgURL = configExtraImgURL;
                }

                var baseIconImgURL = "/img/icons/";
                let configIconImgURL: string = this._configDataService.getClientConfig(enumClientConfig.cconf_IconImageFolder, baseIconImgURL);
                if (configIconImgURL.trim().length > 0) {
                    this._baseIconImgURL = configIconImgURL;
                }

                break;
        }

        if (fullyLoaded) {
            //get the current BusinessEvent's data
            this.loadBusinessEvent();

            this._subscriptions.push(this._beDataService.invokeSaveFirst.subscribe(step => {
                this.goToPrevious(step);
            }));
        }

        this._fullyLoaded = fullyLoaded;
    }

    private async ngOnDestroy() {
        //clear out any subscriptions
        this.unsubscribe();
    };

    //
    //component management
    //
    private loadBusinessEvent() {
        this._locationOut = this._be.locationOut.description;
        this._locationIn = this._be.locationIn.description;
        this._deliveryAddress = (this._be.deliveryAddress == null ? "" : "to " + this._be.deliveryAddress.replace(/\n/g, ", "));
        this._collectionAddress = (this._be.collectionAddress == null ? "" : "from " + this._be.collectionAddress.replace(/\n/g, ", "));

        var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var timeOptions = { hour: 'numeric', minute: '2-digit' };
        this._dateTimeOut = ((this._be.dateTimeOut == null) ? "<unknown>" :
            this._be.dateTimeOut.toLocaleDateString(navigator.language, dateOptions)
            + " at " + this._be.dateTimeOut.toLocaleTimeString(navigator.language, timeOptions))
        this._dateTimeIn = ((this._be.dateTimeIn == null) ? "<unknown>" :
            this._be.dateTimeIn.toLocaleDateString(navigator.language, dateOptions)
            + " at " + this._be.dateTimeIn.toLocaleTimeString(navigator.language, timeOptions));

        this._vehicleSIPP = this._be.otaVehAvail.vehAvailCore.vehicle.code;
        this._selectedVehicle = this._be.otaVehAvail;

        //remove any Equips that are configured to be hidden
        this._otaPricedEquips = JSON.parse(JSON.stringify(this._be.otaVehAvail.vehAvailCore.pricedEquips));
        if (this._otaPricedEquips != null) {
            this._otaPricedEquips = this._otaPricedEquips.filter(eq => (! this._configDataService.hideExtra(eq)));
        }

        for (var i = 0; i < this._otaPricedEquips.length; i++) {
            let eq = this._otaPricedEquips[i];

            //create an array of whether or not the equip is selected or not
            //use to bind as the ngModel for the single selection equipment checkbox
            this._singleAllowedEquips.push((eq.requestedCount > 0));
        }

        //sort the available coverages, cheapest first
        this._otaPricedCoverages = this._be.otaVehAvail.vehAvailInfo.pricedCoverages.sort((n1, n2) => {
            if (n1.charge.amount > n2.charge.amount) {
                return 1;
            }

            if (n1.charge.amount < n2.charge.amount) {
                return -1;
            }

            return 0;
        });

        //get the currently selected Coverage
        if (this._otaPricedCoverages.length > 0) {
            var defaultCoverage: OTA_PricedCoverage = this._otaPricedCoverages[0];

            for (var i = 0; i < this._otaPricedCoverages.length; i++) {
                let cvr = this._otaPricedCoverages[i];

                if (cvr.selected) {
                    this._originalOTAPricedCoverage = cvr;
                    break;
                }
                else if (cvr.charge.includedInRate) {
                    this._originalOTAPricedCoverage = cvr;
                }
            }

            if ((this._originalOTAPricedCoverage == null) && (this._otaPricedCoverages.length > 1)) {
                this._originalOTAPricedCoverage = defaultCoverage;
            }

            this._singleCoverageSelected = ((this._originalOTAPricedCoverage != null) && (this._otaPricedCoverages.length == 1)) ;
            this._originalSingleCoverageSelected = this._singleCoverageSelected;

            this._otaPricedCoverage = this._originalOTAPricedCoverage;
        }

        this._reference = (this._be.reference == null ? "" : this._be.reference);
        if (this._reference.length > 0)
            this._reference = " - " + this._reference;

        //ensure we're positioned at the top of the page
        window.scroll(0, 0);

        //this.refreshTotalCostDescription();
        this.validateForm();
    }

    private save(): boolean {
        this._be.refresh = this._hasChanged;
        this._be.otaVehAvail.vehAvailCore.pricedEquips = JSON.parse(JSON.stringify(this._otaPricedEquips));

        //get the currently selected Coverage
        if (this._otaPricedCoverages.length == 1) {
            this._otaPricedCoverages[0].selected = (this._singleCoverageSelected);
        }
        else {
            if ((this._otaPricedCoverages.length > 0)
                && (this._otaPricedCoverage != null)) {

                for (var i = 0; i < this._otaPricedCoverages.length; i++) {
                    let cvr = this._otaPricedCoverages[i];
                    cvr.selected = (this._otaPricedCoverage == cvr);
                }
            }
        }

        this._be.rentalChanged = (this._be.rentalChanged || this._hasChanged);

        this._beDataService.setBusinessEventForStep(this._currentStep, this._be);
        return true;
    }

    private goToPrevious(step:string = "") {
        var proceed = true;

        if (step.length == 0)
            step = this._previousStep;

        if (this._hasChanged) {
            if (this._hasError) {
                //clear the Dialog object's array of DialogButtons
                this._dialog.buttons = [];

                //apply the required buttons to the Dialog object
                var btnYes: DialogButton = new DialogButton();
                btnYes.label = "Yes";
                btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
                this._dialog.buttons.push(btnYes);

                var btnNo: DialogButton = new DialogButton();
                btnNo.label = "No";
                btnNo.buttonType = enumDialogButtonType.dlgParam_No;
                this._dialog.buttons.push(btnNo);

                this._confirmationService.confirm({
                    message: 'The data has changed. Do you wish to proceed and lose these changes?',
                    accept: () => {
                        switch (this._dialog.buttonPressed.buttonType) {
                            case enumDialogButtonType.dlgParam_Yes:
                                this.navigateTo(step);
                                break;
                            case enumDialogButtonType.dlgParam_No:
                                break;
                        }
                    }
                });
            }
            else {
                //clear the Dialog object's array of DialogButtons
                this._dialog.buttons = [];

                //apply the required buttons to the Dialog object
                var btnYes: DialogButton = new DialogButton();
                btnYes.label = "Yes";
                btnYes.buttonType = enumDialogButtonType.dlgParam_Yes;
                this._dialog.buttons.push(btnYes);

                var btnNo: DialogButton = new DialogButton();
                btnNo.label = "No";
                btnNo.buttonType = enumDialogButtonType.dlgParam_No;
                this._dialog.buttons.push(btnNo);

                var btnCancel: DialogButton = new DialogButton();
                btnCancel.label = "Cancel";
                btnCancel.buttonType = enumDialogButtonType.dlgParam_Cancel;
                this._dialog.buttons.push(btnCancel);

                this._confirmationService.confirm({
                    message: 'The data has changed. Do you wish to save it?',
                    accept: () => {
                        switch (this._dialog.buttonPressed.buttonType) {
                            case enumDialogButtonType.dlgParam_Yes:
                                if (this.save())
                                    this.navigateTo(step);
                                break;
                            case enumDialogButtonType.dlgParam_No:
                                this._beDataService.changeStep(this._currentStep, false);
                                this.navigateTo(step);
                                break;
                            case enumDialogButtonType.dlgParam_Cancel:
                                
                                break;
                        }
                    },
                });
            }
        }
        else 
            this.navigateTo(step);
    }

    private goToNext() {
        if (this.save()) {
            //navigate to the next page
            this.navigateTo(this._nextStep);
        }
    }

    private navigateTo(step: string) {
        //navigate to the given page
        if (step.trim().length > 0)
            this._router.navigate(['/' + step]);
    }

    //
    //control events
    //
    private spinExtra(selectedOTAPricedEquip: OTA_PricedEquip, increment: boolean) {
        var newRequestedCount: number = selectedOTAPricedEquip.requestedCount;

        if (increment)
            newRequestedCount++;
        else
            newRequestedCount--;

        selectedOTAPricedEquip.requestedCount = (newRequestedCount < 0 ? 0 : (newRequestedCount > selectedOTAPricedEquip.equipment.maximumAllowed ? selectedOTAPricedEquip.equipment.maximumAllowed : newRequestedCount));
        //selectedOTAPricedEquip.equipment.quantity = selectedOTAPricedEquip.requestedCount;

        this.validateForm();
    }

    private selectExtra(eq:OTA_PricedEquip) {
        eq.requestedCount = 1 - eq.requestedCount;
        this.validateForm();
    }

    private selectCover(cvr: OTA_PricedCoverage) {
        this._otaPricedCoverage = cvr;
        this.validateForm();
    }

    //
    //validation methods
    //
    private validateForm() {
        //check if the Extras have changed.
        if (this._otaPricedCoverages.length == 1) {
            this._hasChanged = (this._singleCoverageSelected != this._originalSingleCoverageSelected);
        }
        else {
            this._hasChanged = (this._otaPricedCoverage != this._originalOTAPricedCoverage);
        }

        if (!this._hasChanged) {
            for (var i = 0; i < this._otaPricedEquips.length; i++) {
                let eq = this._otaPricedEquips[i];

                var originalEq = this._be.otaVehAvail.vehAvailCore.pricedEquips.find(pEq => pEq.equipment.equipType == eq.equipment.equipType);
                if ((originalEq == null)
                    || (originalEq.requestedCount != eq.requestedCount))
                {
                    this._hasChanged = true;
                    break;
                }
            }
        }

        this._beDataService.changeStep(this._currentStep, this._hasChanged);

        this._hasError = ((this._nextStep.length == 0)
            || (this._previousStep.length == 0));

        //this.refreshTotalCostDescription();
    }

    //
    //helper methods
    //
    private formatEquipCharge(eq: OTA_PricedEquip, mode: enumCostDisplayMode): string {
        var charge = "";
        var unit = "";
        let cost: CurrencyAmount = new CurrencyAmount();
        var quantity = eq.equipment.quantity;

        //if (eq.charge.includedInEstTotalInd)
        //    quantity++;

        cost.amount = OTA_Charge.chargeTotal(eq.charge) / quantity;
        cost.currencyCode = eq.charge.currencyCode;

        if (mode == enumCostDisplayMode.exCost_DailyRate) {
            if (eq.charge.calculations != null) {
                eq.charge.calculations.forEach(function (calc) {
                    cost.amount = cost.amount / calc.quantity;
                    unit = calc.unitName
                });
            }            
        }

        charge = this._configDataService.formatCurrencyAmount(cost) + (unit.length > 0 ? " / " + unit : "");

        return charge;
    }

    private formatChargeTotal(chg: OTA_Charge, mode: enumCostDisplayMode): string {
        var charge = "";
        var unit = "";
        let cost: CurrencyAmount = new CurrencyAmount();

        cost.amount = OTA_Charge.chargeTotal(chg);
        cost.currencyCode = chg.currencyCode;
        
        if (mode == enumCostDisplayMode.exCost_DailyRate) {
            if (chg.includedInRate) {
                return "Included";
            }
            else {
                if (chg.calculations != null) {
                    chg.calculations.forEach(function (calc) {
                        cost.amount = cost.amount / calc.quantity;
                        unit = calc.unitName
                    });
                }    
            }
        }

        charge = this._configDataService.formatCurrencyAmount(cost) + (unit.length > 0 ? " / " + unit : "");

        return charge;
    }

    private formatCoverExcess(cvr: OTA_PricedCoverage): string {
        let currAmnt: CurrencyAmount = new CurrencyAmount();
        currAmnt.currencyCode = cvr.currencyCode;
        currAmnt.amount = cvr.excessAmount;

        return this._configDataService.formatCurrencyAmount(currAmnt);
    }

    private vehicleImageURL(vehAvail: OTA_VehAvail): string {
        var imageURL = ""

        if ((vehAvail != null)
            && (vehAvail.vehAvailCore != null)
            && (vehAvail.vehAvailCore.vehicle != null)) {

            //imageURL = vehAvail.vehAvailCore.vehicle.vehicleImageRef;
            imageURL = vehAvail.vehAvailCore.vehicle.code + ".png";

            if (imageURL.length > 0)
                imageURL = this._baseVehImgURL + imageURL;
        }

        return imageURL;
    }

    private extraImageURL(eq: OTA_PricedEquip): string {
        var imageURL = "extra.png"

        if ((eq != null)
            && (eq.equipment != null)) {

            imageURL = eq.equipment.equipType + ".png";
        }

        imageURL = this._baseExtraImgURL + imageURL;

        return imageURL;
    }

    private radioImageURL(isSelected: boolean): string {
        let url: string = this._baseIconImgURL + "radio_button_unchecked.png";

        if (isSelected) {
            url = this._baseIconImgURL + "radio_button_checked.png";
        }

        return url;
    }

    private onVehicleImgError(event) {
        event.target.src = this._baseVehImgURL + "Coming_Soon.png";
    }

    private onExtraImgError(event) {
        event.target.src = this._baseExtraImgURL + "Coming_Soon.png";
    }

    private EquipmentCountRange(eq: OTA_PricedEquip) {
        var result: number[] = [];
        for (var i = 0; i <= eq.equipment.maximumAllowed; i++) {
            result.push(i);
        }
        return result;
    };

    //private refreshTotalCostDescription() {
    //    var totalCostDescription = "";

    //    if ((this._be.otaVehAvail != null)
    //        && (this._be.otaVehAvail.vehAvailCore != null)
    //        && (this._be.otaVehAvail.vehAvailCore.totalCharge != null)) {

    //        let cost: CurrencyAmount = new CurrencyAmount();
    //        cost.amount = this._be.otaVehAvail.vehAvailCore.totalCharge.estimatedTotalAmount;
    //        cost.currencyCode = this._be.otaVehAvail.vehAvailCore.totalCharge.currencyCode;

    //        //add on the cost of any selected PricedEquips
    //        for (var i = 0; i < this._otaPricedEquips.length; i++) {
    //            let eq = this._otaPricedEquips[i];

    //            var originalEq = this._be.otaVehAvail.vehAvailCore.pricedEquips.find(pEq => pEq.equipment.description == eq.equipment.description);
    //            if ((eq.requestedCount > 0)
    //                && ((eq.charge.amount != 0) || (eq.charge.taxAmounts[0].total != 0))) {
    //                cost.amount = cost.amount + (eq.requestedCount * (eq.charge.amount + eq.charge.taxAmounts[0].total));
    //            }
    //        }

    //        //add on the cost of any selected PricedCoverages
    //        cost.amount = cost.amount + this._otaPricedCoverage.charge.amount + this._otaPricedCoverage.charge.taxAmounts[0].total;

    //        totalCostDescription = CurrencyAmount.formatCurrencyAmount(cost);
    //    }

    //    this._totalCostDescription = totalCostDescription;
    //}

    //
    //dialog management
    //
    private dialogButtonPressed(button: DialogButton) {
        //record which button was pressed
        this._dialog.buttonPressed = button;
    }

    private unsubscribe() {
        this._subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this._subscriptions = [];
    }
}
